<template>
  <div class="header">
    <header-navigation :showInfo="showInfo" v-on:toggle-info="toggleInfo"/>
    <header-help :showInfo="showInfo" v-on:toggle-info="toggleInfo"/>
  </div>
</template>

<script>
  import HeaderNavigation from "./HeaderNavigation";
  import HeaderHelp from "./HeaderHelp";

  export default {
    name: "AppHeader",
    components: {HeaderHelp, HeaderNavigation},
    data() {
      return {
        showInfo: true
      }
    },
    methods: {
      toggleInfo() {
        this.showInfo = !this.showInfo;
        if (this.showInfo === false) {
          this.$store.commit('disableInfoOnStartup');
        }
      }
    },
    mounted() {
      this.showInfo = this.$store.state.showInfoOnStartup;
    }
  }
</script>

<style lang="scss">
</style>